import dateField from "../../common/date-field";
import decimalField from "../../common/decimal-field.vue";
import TableList from "../../sub-components/Generic/TableList/TableList.vue";
import ModalTransactionGet from "../../sub-components/Generic/ModalTransactionGet/ModalTransactionGet.vue";
import { hasValue } from "../../../utils/functions.js";

const customer = [
  { field: "Customer.Name", class: "text-left" },
  { field: "Customer.Identity", type: 'identity', class: "identity text-left" }
];

const returnCode = [
  { field: "PaymentObject.ReturnCode", class: "text-left" },
  { field: "PaymentObject.MessageProvider", class: "same-line text-left" }
];

const retryPolicy = [
  { field: "PaymentObject.IsRetryAllowed", class: "text-left", type: "YesNoIcon" },
  { field: "PaymentObject.RetryPolicy", class: "same-line text-left" }
];

export default {
  name: "TransactionCreditCardRefused",
  components: {
    dateField,
    decimalField,
    TableList,
    ModalTransactionGet
  },
  data() {
    return {
      LoadingTransactionList: false,
      LoadingReport: false,
      LoadingBrands: false,
      LoadingGateway: false,
      LoadingSelectedTransaction: false,
      permissionController: 'Transaction',
      headers: [
        { field: "Id", label: "Transação", classHeader: 'text-left', classField: 'text-left' },
        { field: "Merchant.Id", label: "Merchant", classHeader: 'text-left', classField: 'text-left' },
        { field: customer, label: "Cliente", classHeader: 'text-left', classField: 'text-left same-line' },
        { field: "Amount", label: "Valor", type: "currency", classHeader: 'text-left', classField: 'text-left' },
        { field: "Gateway.Name", label: "Adquirente", classHeader: 'text-left', classField: 'text-left' },
        { field: "PaymentObject.Brand.Name", label: "Bandeira", classHeader: 'text-left', classField: 'text-left' },
        { field: returnCode, label: "Retorno da Operadora", classHeader: 'text-left', classField: 'text-left' },
        { field: retryPolicy, label: "Permite Retentativa", classHeader: 'text-left', classField: 'text-left' },
        { field: "CreatedDate", label: "Data", type: "dateTime", classHeader: 'text-left', classField: 'text-left' },
      ],
      transactionList: [],
      countFilter: 0,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      BankList: [],
      brandList: [],
      gatewayList: [],
      filter: this.FilterDefault(),
      infoTransaction: this.InfoTransactionDefault(),
      showTransactionModal: false,
      isSeeing: false,
      modalTitle: "Detalhe da transação",
      mSteps: ["Cliente", "Pagamento", "Produto", "Histórico de Status", "Splits", "Informações Adicionais"],
      transactionStatus: [],
      idMerchant: null,
      paymentMethods: [],
      subcontas: [],
      mCurrentStep: 0,
      redirectOpen: false,
      tableKey: 0,
      taxPaymentMethod: null,
      ticketsTableKey: 0,
      selected_payment: null,
      validatedFormValidation: false,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  watch: {
    "pagination.PageNumber"() {
      this.ListCreditCardRefused();
    },
    "pagination.RowsPerPage"() {
      this.ListCreditCardRefused();
    }
  },
  computed: {
    IsLoading() {
      return this.LoadingTransactionList || this.LoadingBrands || this.LoadingReport || this.LoadingGateway;
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.ListTransactionStatus();
    this.ListPaymentMethod();
    this.ListBrand();
    this.ListGatewayCreditCard();
    this.ListCreditCardRefused();
  },
  methods: {
    OpenModalTransaction(transaction) {
      this.ResetinfoTransaction();
      this.GetTransaction(transaction.Id, transaction.Merchant.Id);
    },
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },
    Filter() {
      this.validatedFormValidation = true;
      this.$refs.ValidationForm.validate().then(isValid => {
        if (isValid) {
          this.$bvModal.hide("mFilter");
          this.ListCreditCardRefused();
        }
      });
    },
    ResetFilter() {
      this.filter = this.FilterDefault();
      this.countFilter = 0;
      this.transactions = [];
      this.pagination.TotalItems = 0;

      this.ListCreditCardRefused();
    },
    FilterDefault() {
      return {
        TransactionId: null,
        MerchantId: null,
        GatewayId: null,
        BrandId: null,
        ReturnCode: null,
        MessageProvider: null,
        Bin: null,
        Last4: null,
        CustomerName: null,
        CustomerIdentity: null,
        CustomerEmail: null,
        Amount: null,
        CreatedDateInitial: null,
        CreatedDateEnd: null
      };
    },
    ColumnsConfigChanged() {
      sessionStorage.setItem("Columns", JSON.stringify(this.Columns));
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ListCreditCardRefused() {
      this.countFilter = 0;
      Object.values(this.filter).map(value => {
        if (hasValue(value)) this.countFilter++;
      });
      this.LoadingTransactionList = true;
      let params = this.GetParamsData();
      this.$store
        .dispatch("ListCreditCardRefused", params)
        .then(response => {
          this.transactionList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => this.$makeToast(undefined, "danger", "Erro ao listar as transações", error))
        .finally(() => (this.LoadingTransactionList = false));
    },
    GetReport() {
      this.LoadingTransactionList = true;
      const params = this.GetParamsData(true);
      this.$store.dispatch("ReportCreditCardRefused", params)
        .then(response => {
          if (hasValue(response.UrlReport)) {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error))
        .finally(() => {
          setTimeout(() => {
            this.LoadingTransactionList = false;
          }, 1200);
        });
    },
    GetParamsData(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Id": this.filter.TransactionId,
        "Object.Merchant.Id": this.filter.MerchantId,
        "Object.Brand.Id": this.filter.BrandId,
        "Object.ReturnCode": this.filter.ReturnCode,
        "Object.MessageProvider": this.filter.MessageProvider,
        "Object.Bin": this.filter.Bin,
        "Object.Last4": this.filter.Last4,
        "Object.Gateway.Id": this.filter.GatewayId,
        "Object.Customer.Name": this.filter.CustomerName,
        "Object.Customer.Identity": this.filter.CustomerIdentity,
        "Object.Customer.Email": this.filter.CustomerEmail,
        "Object.Amount": this.filter.TransactionAmount,
        "CreatedDateInitial": this.filter.CreatedDateInitial,
        "CreatedDateEnd": this.filter.CreatedDateEnd
      };

      delete data.TotalItems;
      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }

      return data;
    },
    ListBrand() {
      this.LoadingBrand = true;
      this.$store
        .dispatch("ListBrand", {})
        .then(response => {
          this.brandList = response;
        })
        .catch(error => {
          this.$makeToast("Tente atualizar a página.", "danger", "Erro ao listar as bandeiras", error);
        })
        .finally(() => (this.LoadingBrand = false));
    },
    ListGatewayCreditCard() {
      this.LoadingGateway = true;
      this.$store
        .dispatch("GatewayListCreditCard", {})
        .then(response => {
          this.gatewayList = response;
        })
        .catch(error => {
          this.$makeToast("Tente atualizar a página.", "danger", "Erro ao listar os adquirentes", error);
        })
        .finally(() => (this.LoadingGateway = false));
    },
    InfoTransactionDefault() {
      return {
        Id: 0,
        Reference: null,
        Vendor: null,
        Application: null,
        Customer: {
          Name: null,
          Identity: null,
          Email: null,
          Address: {
            ZipCode: null,
            Street: null,
            Number: null,
            District: null,
            Complement: null,
            City: {
              Name: null,
              Initials: null
            },
            State: {
              Initials: null
            }
          }
        },
        PaymentMethod: {
          Code: null,
          BankSlipNumber: null,
          DueDate: null,
          InstallmentQuantity: null
        },
        PaymentObject: {
          Symbol: null,
          Brand: {
            Code: null
          },
          Amount: null,
          Address: null,
          Provider: null,
          ReturnCode: null,
          MessageProvider: null,
          AdditionPayment: null,
          DiscountPayment: null,
          QrCode: null,
          BankData: {
            BankAgency: null,
            BankAgencyDigit: null,
            BankAccount: null,
            BankAccountDigit: null,
            Bank: {
              Name: null
            }
          }
        },
        Amount: null,
        PaymentDate: null,
        CreatedDate: null,
        CheckingAccounts: [],
        Splits: [],
        History: [],
        IsSplitter: false,
        Products: [],
        Plan: {
          Name: null
        },
        TransactionStatus: {
          Code: "1"
        }
      };
    },
    ResetinfoTransaction() {
      this.infoTransaction = this.InfoTransactionDefault();
    },
    GetTransaction(id, idMerchant) {
      this.LoadingSelectedTransaction = true;
      this.showTransactionModal = true;
      this.$store
        .dispatch("GetTransaction", { id: id, idMerchant: idMerchant })
        .then(response => {
          this.infoTransaction = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter as informações da transação", error);
        })
        .finally(() => {
          this.LoadingSelectedTransaction = false;
        });
    },
    ListTransactionStatus() {
      this.$store
        .dispatch("ListTransactionStatus", {})
        .then(response => {
          this.transactionStatus = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro carregar a lista de status", error);
        });
    },
    ListPaymentMethod() {
      this.$store
        .dispatch("ListPaymentMethod")
        .then(response => {
          this.paymentMethods = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de tipos de pagamento", error);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/TransactionCreditCardRefused/TransactionCreditCardRefused.js